var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"errorPageContainer"}},[_c('div',{staticClass:"errorCode"},[_vm._v("TODO: Error Seite für Mandy anpassen")]),_c('div',{staticClass:"oops"},[_vm._v("Oops!")]),_c('div',{staticClass:"errorCode"},[_vm._v("404 - Seite nicht gefunden")]),_c('div',{staticClass:"errorText"},[_vm._v("Die angeforderte URL wurde auf dem Server nicht gefunden.")])])
}]

export { render, staticRenderFns }